<template>
<div>
  <vue-headful :title="site_title" />
  <Header />
  <!-- pages widget -->
  <template v-if="this.response">
    <ThreadPages :totalItems="this.response.totalItems" :itemsPerPage="40" :prependIntoLink="'index.php?act=Members'" />
    <table style="width:100%">
      <tr v-for="member in this.response.members">
        <td style="text-align: center; width: 50px;">{{member.id}} </td>
        <th style="width: 100px;">{{htmlDecode(member.name)}} </th>
        <td style="width: 300px;">{{member.avatar_old}} </td>
        <td style="padding: 5px"><img class="avatar" :src="fixAvatarPath(member.avatar_old)" /></td>
        <td style="width: 300px;">{{member.avatar_new}} </td>
        <td style="padding: 5px"><img class="avatar" :src="fixAvatarPath(member.avatar_new)" /></td>
      </tr>
    </table>
    <FooterPermanent v-if="this.footerReady" :loadTime="this.loadTime" :totalRequests="this.response.queries" />
  </template>
</div>
</template>

<script>
import Header from './Header'
import FooterPermanent from './FooterPermanent'
import ThreadPages from './ThreadPages'

export default {
  components: {
    Header,
    FooterPermanent,
    ThreadPages
  },
  data: function() {
    return {
      response: null,
      footerReady: false
    }
  },
  async created() {
    console.time("PageLoadTime");
    let dateEarly = new Date();
    let pagenumber = 0;
    if (this.$route.query.st) {
      pagenumber = Number(this.$route.query.st);
    }
    let response = await fetch(this.getNodePath() + 'members/' + pagenumber);
    let dateLater = new Date();
    this.response = await response.json();
    this.loadTime = this.spanSeconds(dateEarly, dateLater);
    this.footerReady = true;
    console.timeEnd("PageLoadTime");
  }
}
</script>

<style lang="scss">
</style>
